import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import { QueryClientProvider } from '@tanstack/react-query';
import { antdTheme, queryClient } from '@/lib';
import { ErrorBoundary } from '@/shared/components/feedback';
import App from '@/app/App';
import '@/app/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={antdTheme}>
        <App />
      </ConfigProvider>
    </QueryClientProvider>
  </ErrorBoundary>,
);
